export default "__VITE_ASSET__DCGUVpAe__"